var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('formulaire-bilan',{attrs:{"mode":"create"},on:{"quitter":function($event){_vm.peut_quitter=true}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }